<template>
  <v-flex xs12>
    <v-card class="e-carousel primary radius e-elevation--4">
      <v-card-text class="py-4">
        <div class="e-carousel-number">{{ number }}</div>
        <p class="e-description-middle white--text text-xs-center">{{ descripcion }}</p>
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<script>
export default {
  name: 'CardCarousel',
  props: {
    number: {
      type: Number,
      default: 1
    },
    descripcion: {
      type: String,
      default: '저는 가고 있어요. 저는 지금 택시에 있어요. 잠깐만 기다려 주세요.'
    },
    seleccionado: {
      type: Boolean,
      default: false
    }
  }
}
</script>

